import React from 'react';
import useCRM from '@ubeya/shared/hooks/account/useCRM';
import { FlexMiddle } from '../../Flex';

const WorkedWithClientFilterChip = ({ value }) => {
  const { mappedClients } = useCRM();

  return <FlexMiddle>{value.map((item) => mappedClients[item]?.name).join(', ')}</FlexMiddle>;
};

export default WorkedWithClientFilterChip;
